// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Glyphicon } from 'react-bootstrap';
import { truncateHoursString } from '../utils';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const BookingOptionListElement = ({ value, onBookingOptionEdit }) => (
  <tr
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    key={value?.id}
    onClick={() => onBookingOptionEdit(value)}
    className='listrow moveable'
  >
    <td style={{ verticalAlign: 'middle' }}>
      <Glyphicon glyph='option-vertical' />
    </td>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td>{value?.title}</td>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td dangerouslySetInnerHTML={{ __html: value?.description }} />
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td>{value?.duration}</td>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td title={value?.hours}>{truncateHoursString(value?.hours)}</td>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td>{value?.interval}</td>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td>{value?.price}</td>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td>{value?.pricingModel}</td>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <td>{value?.subType === 'addon' ? 'Addon' : 'Booking Option'}</td>
  </tr>
);

export default BookingOptionListElement;
